export const environment = {
    production: false,
    apiBaseUrl: 'https://amarant-dev-api-cmeafza3cyg5fhgr.northeurope-01.azurewebsites.net',
    apiVersion: 'v1'
};
